<template>
  <h2 style="text-align: center;">All products</h2>
  <div class="row mt-2">
    <div class="col-md-8">
      <table class="table responsive-table">
        <thead>
          <tr>
            <th>Product name</th>
            <th>Edit</th>
            <th>Print</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(product, index) in store.getAllProducts()" :key="index">
            <td>{{ product.productName }}</td>
            <td>
              <icon-svg
                icon="line-md:edit"
                :height="25"
                :width="25"
                @click="editDesign(product)"
              />
            </td>
            <td>
              <icon-svg
                icon="ic:round-local-printshop"
                :height="25"
                :width="25"
                @click="printDesign(product)"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="this.designPopupOpen" :key="this.designPopupCount">
        <ProductDesign></ProductDesign>
      </div>
      <div v-if="this.printPopupOpen" :key="this.printPopupCount">
        <EmbroidMechine 
          :product="this.productToEdit" 
          :imageName="store.allProducts[this.productToEdit.productID].images[
            Object.keys(store.allProducts[this.productToEdit.productID].images)[0]].imageName
        ">
        </EmbroidMechine>
      </div>
    </div>
  </div>
  <div class="columns">
    <template>
      <div class="column is-2"></div>

      <span>&nbsp;</span>
    </template>
  </div>
</template>


<script>
import { designerStore } from "@/stores/designerStore";
import ProductDesign from "./ProductDesign.vue";
import EmbroidMechine from "./EmbroidMechine.vue";

export default {
  setup() {
    const store = designerStore();
    return {
      store,
    };
  },
  data() {
    return {
      designPopupOpen: false,
      designPopupCount: 0,
      productToEdit: null,

      printPopupOpen: null,
      printPopupCount: 0,
    };
  },
  components: {
    ProductDesign,
    EmbroidMechine,
  },
  methods: {
    editDesign(product) {
      this.designPopupOpen = true;
      this.designPopupCount++;
      this.productToEdit = product;
    },
    printDesign(product){
      this.printPopupOpen = true;
      this.printPopupCount++;
      this.productToEdit = product;
    },
  },
};
</script>
 <style >
.oultine-text {
  -webkit-text-stroke: 0.5px black;
  border: 1px black solid;
  width: 100px;
}
</style>

